import { CECertificateAttributesBase } from './ce-certificate-attributes-base'


export class CECertificateAttributes extends CECertificateAttributesBase {

}